
import { useEffect, useState, } from 'react'
import { InputImage } from '../components/InputImage'
import { CardFormInput } from '../components/CardFormInput'
const fileReader = new FileReader()

export function CreateCard({ 
  handleCreateCardSubmit,
  handleImageUpload,
  handleChange,
  formData,
  file,
  setFormData,
}) {
  fileReader.onload = (fileEvent) => {
    const srcData = fileEvent.target.result;
    setFormData({
      ...formData,
      ref: srcData
    })
  }

  return (
    <>
      <h1 className='text-5xl'>Create Card</h1>
      <div className='m-8 '>
        <form>
          <h1 className='text-xl font-bold'>Create a new card entry!</h1>
          <div>
            <CardFormInput 
              dataProperty='name'
              formData={ formData }
              inputText='Name'
              placeholderText='What is my name?' 
              handleChange={ handleChange } 
              isRequired={true}
            />
            <CardFormInput 
              dataProperty='description'
              formData={ formData }
              inputText='Description'

              handleChange={ handleChange } 
              isRequired={true}
            />
            <CardFormInput 
              dataProperty='price'
              formData={ formData }
              inputText='Price'
              handleChange={ handleChange } 
              isRequired={true}
            />
            <InputImage
              id='image'
              title='Image File'
              type='file'
              placeHolderText='What picture of me do you want to use?'
              handleImageUpload={handleImageUpload}
              isRequired={true}
              file={file} />
            <CardFormInput 
              dataProperty='available'
              formData={ formData }
              inputText='Available'
              handleChange={ handleChange } 
              isRequired={true}
            />
            <CardFormInput 
              dataProperty='dealVerbiage'
              formData={ formData.deal }
              inputText='dealVerbiage'
              handleChange={ handleChange } 
              isRequired={true}
            />
            <CardFormInput 
              dataProperty='lot'
              formData={ formData.deal }
              inputText='Lot Per Deal Price'
              handleChange={ handleChange } 
              isRequired={true}
            />
            <CardFormInput 
              dataProperty='pricePerLot'
              formData={ formData.deal }
              inputText='Price Per Lot'
              handleChange={ handleChange } 
              isRequired={true}
            />
          </div>
          <button className='max-w-[600px] ml-2 p-2 mt-8 bg-red-800 rounded-lg text-black font-bold w-[80%]' onClick={handleCreateCardSubmit}>submit</button>
        </form>
        {/* { formData ? <p>{ JSON.stringify(formData, null, 2) }</p>: null} */}
      </div>
    </>
  )
}